import {useEffect, useState} from "react";
import {ProjectApi} from "../authority/generated/index";
import useAuthorityConfiguration from "./useAuthorityConfiguration.js";

export default function useProjectDomains(project) {
    let [projectDomains, setProjectDomains] = useState(null);
    let authorityConfiguration = useAuthorityConfiguration();

    useEffect(() => {
        setProjectDomains(null);

        new ProjectApi(authorityConfiguration)
            .listProjectDomains({
                projectId: project.id,
            })
            .then(setProjectDomains)
            .catch(() => setProjectDomains([]));

    }, [project.id]);

    return projectDomains;
}